import { SET_USER_INFO, SET_USER_SETTINGS } from "../types";

export default (state, action) => {
    switch (action.type) {
        case SET_USER_INFO: {
            return {
                ...state,
                user: action.payload
            }
        }
        case SET_USER_SETTINGS: {
            return {
                ...state,
                settings: action.payload
            }
        }

    }
}